import { useState } from "react";
import {Alert, Box, Grid, TextField} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { t } from "i18next";
import api from "../../../../../helpers/api/Api";
import ApiUrls from "../../../../../helpers/urls/ApiUrls";
import { showStatus } from "../../../../../helpers/api/errors/ShowStatus";
import CustomModal from "../../../../../components/Modal";

function CleanCacheURL({ domain, setOpen }) {
  const [uri, setUri] = useState("");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [alert, setAlert] = useState(false);

  const checkInputs = () => {
    let temp_errors = {};

    if (uri === "") {
      temp_errors.uri = t("message.required", { item: t("domain.url_address") });
    }
    setErrors(temp_errors);

    if (Object.keys(temp_errors).length === 0) {
      editCache();
    }
  }

  const editCache = () => {
    setAlert(false);
    setLoading(true);

    let postFormData = new FormData();
    postFormData.append('uid', domain.id);
    postFormData.append('uri', uri);

    const snackArgs = {
      item: t("domain.cache_uri_cleaning"),
      op: t("global.done")
    };

    api.post(ApiUrls.domain.cleanCache, postFormData)
      .then((response) => {
        setLoading(false);
        if (response.data.status === "toofast") {
          setAlert(true);
        } else {
          showStatus(response.data.status, snackArgs);
          if (response.data.status === "success") {
            setOpen("");
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        showStatus("error", snackArgs);
      });
  }

  return (
     <CustomModal
        open={true}
        handleClose={() => setOpen("")}
        title={t("domain.cache_uri_cleaning")}
     >
       <Box py={2} px={{ md: 5, xs: 2 }}>
         <Grid container spacing={2} justifyContent="center" alignItems="center">
           {alert &&
              <div className="d-flex justify-content-center">
                <Grid item xs={10} mt={3}>
                  <Alert severity="error">
                    {t("domain.too_fast_error")}
                  </Alert>
                </Grid>
              </div>
           }

           <Grid container justifyContent="center" mt={3}>
             <Grid item md={5} xs={12}>
               <TextField id="uri" label={t("domain.url_address")} variant="outlined" fullWidth
                          value={uri} error={!!errors.uri} helperText={errors.uri} className="ltr-textfield"
                          onChange={(e) => setUri(e.target.value)}
               />
             </Grid>
           </Grid>

           <Grid item md={12} mt={3} className="d-flex justify-content-center">
             <LoadingButton
                color="info"
                loading={loading}
                variant="outlined"
                onClick={checkInputs}
             >
               {t("button.run")}
             </LoadingButton>
           </Grid>
         </Grid>
       </Box>
     </CustomModal>
  )
}

export default CleanCacheURL;
